// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__hZY8n","iconWithCounter":"styles_iconWithCounter__aD6Qe","counterForLabel":"styles_counterForLabel__bnI_N","counterForIcon":"styles_counterForIcon__Oax2o"};